var _path, _line, _line2, _line3, _line4, _line5, _line6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocial3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 1080,
    viewBox: "0 0 1080 1080",
    width: 1080,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M157.5 296C157.5 220.613 218.613 159.5 294 159.5H781C856.387 159.5 917.5 220.613 917.5 296V783C917.5 858.387 856.387 919.5 781 919.5H294C218.613 919.5 157.5 858.387 157.5 783V296Z",
    stroke: "url(#paint0_linear)",
    strokeWidth: 27
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    stroke: "#EAEAEA",
    strokeOpacity: 0.7,
    strokeWidth: 27,
    x1: 319.031,
    x2: 761.031,
    y1: 662.5,
    y2: 663.523
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    stroke: "#EAEAEA",
    strokeOpacity: 0.7,
    strokeWidth: 27,
    x1: 315.031,
    x2: 757.031,
    y1: 418.5,
    y2: 419.523
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    stroke: "#FF4141",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 27,
    x1: 761.54,
    x2: 761.54,
    y1: 661.887,
    y2: 418.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    stroke: "#FF4141",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 27,
    x1: 316.54,
    x2: 316.54,
    y1: 661.887,
    y2: 418.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    stroke: "#FF0101",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 27,
    x1: 317.796,
    x2: 534.691,
    y1: 419.912,
    y2: 571.204
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    stroke: "#FF0101",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 27,
    x1: 541.388,
    x2: 758.276,
    y1: 571.955,
    y2: 420.652
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint0_linear",
    x1: 241,
    x2: 879.973,
    y1: 933,
    y2: 149.239
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4141",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0101"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial3);
export default __webpack_public_path__ + "static/media/social3.575d9cd5459e8e8c9d8d658377a8a341.svg";
export { ForwardRef as ReactComponent };